import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ButtonModule, IconButtonModule, IconModule } from '@liberty-financial/ng-components';

import { ModalComponent, ModalContent, ModalFooter, ModalHeader } from './modal/modal.component';
import { DetailsContent, DetailsModalComponent } from './details-modal/details-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { SelectionModalComponent } from './selection-modal/selection-modal.component';
import { SelectionModule } from '../selection/selection.module';

@NgModule({
  declarations: [
    ConfirmModalComponent,
    SelectionModalComponent,
    ModalComponent,
    ModalHeader,
    ModalContent,
    ModalFooter,
    DetailsModalComponent,
    DetailsContent
  ],
  imports: [
    ModalModule,
    CommonModule,
    SelectionModule,
    ButtonModule,
    IconButtonModule,
    IconModule
  ],
  exports: [
    ConfirmModalComponent,
    SelectionModalComponent,
    ModalComponent,
    ModalContent,
    ModalFooter,
    ModalHeader,
    DetailsModalComponent,
    DetailsContent
  ]
})
export class SparkPlusModalModule { }
